import { render } from "./DialogDescription.vue?vue&type=template&id=4386c83a&ts=true"
import script from "./DialogDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./DialogDescription.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/dialog/DialogDescription.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4386c83a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4386c83a', __exports__)) {
    api.reload('4386c83a', __exports__)
  }
  
  module.hot.accept("./DialogDescription.vue?vue&type=template&id=4386c83a&ts=true", () => {
    api.rerender('4386c83a', render)
  })

}


export default __exports__